import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { scrollToId } from "@/lib/scroll";

const LINES = ["WHERE REAL LIFE", "BECOMES A STORY", "WORTH REPLAYING."];

export const Hero = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start start", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], [0, 200]);
  const opacity = useTransform(scrollYProgress, [0, 0.85], [1, 0]);

  return (
    <section
      id="hero"
      ref={ref}
      data-testid="hero-section"
      className="relative flex min-h-screen flex-col justify-center overflow-hidden bg-[#050505]"
    >
      <motion.div
        aria-hidden="true"
        initial={{ scale: 1.08, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ duration: 2.2, ease: [0.16, 1, 0.3, 1] }}
        className="absolute inset-0"
      >
        <img
          src="https://customer-assets-lxgj4vgw.emergentagent.net/job_story-in-motion-7/artifacts/hqrzzw1o_20260530_162233%280%29.jpeg"
          alt=""
          className="h-full w-full object-cover object-[center_20%]"
        />
        <div className="absolute inset-0 bg-black/55" />
        <div
          className="absolute inset-0"
          style={{
            background:
              "linear-gradient(to right, #050505 8%, rgba(5,5,5,0.78) 45%, rgba(5,5,5,0.30) 100%)",
          }}
        />
        <div className="absolute inset-x-0 bottom-0 h-48 bg-gradient-to-t from-[#050505] to-transparent" />
      </motion.div>

      <motion.div style={{ y, opacity }} className="relative z-10 px-5 sm:px-10">
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.9, duration: 0.8 }}
          className="mb-8 flex items-center gap-3"
        >
          <span className="animate-rec inline-block h-2 w-2 rounded-full bg-[#E63946]" />
          <span className="font-mono text-[10px] uppercase tracking-[0.35em] text-[#8E8E93] sm:text-xs">
            REC — REAL-LIFE FOOTAGE ONLY
          </span>
        </motion.div>

        <h1 className="font-display text-[clamp(3.2rem,11vw,10.5rem)] font-black uppercase leading-[0.88] tracking-tight text-[#F3F3F5]">
          {LINES.map((line, i) => (
            <span key={line} className="block overflow-hidden pb-1">
              <motion.span
                initial={{ y: "112%" }}
                animate={{ y: 0 }}
                transition={{ duration: 1.1, delay: 0.15 + i * 0.14, ease: [0.16, 1, 0.3, 1] }}
                className="block"
              >
                {line}
              </motion.span>
            </span>
          ))}
        </h1>

        <motion.p
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.85, duration: 0.8 }}
          className="mt-8 max-w-xl text-sm leading-relaxed text-[#8E8E93] sm:text-base"
        >
          Real-life video editing for creators, businesses, events, vlogs, and everyday moments.
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 1, duration: 0.8 }}
          className="mt-10 flex flex-wrap items-center gap-4"
        >
          <button
            data-testid="hero-view-services-button"
            onClick={() => scrollToId("services")}
            className="border border-white/25 px-8 py-4 font-mono text-xs uppercase tracking-[0.25em] text-[#F3F3F5] transition-colors duration-300 hover:border-white hover:bg-white hover:text-[#050505]"
          >
            VIEW SERVICES
          </button>
          <button
            data-testid="hero-start-project-button"
            onClick={() => scrollToId("contact")}
            className="bg-[#F3F3F5] px-8 py-4 font-mono text-xs uppercase tracking-[0.25em] text-[#050505] transition-colors duration-300 hover:bg-[#E63946] hover:text-white"
          >
            START A PROJECT
          </button>
        </motion.div>
      </motion.div>

      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 1.4, duration: 1 }}
        className="absolute inset-x-0 bottom-0 z-10 flex items-end justify-between px-5 pb-6 sm:px-10"
      >
        <span className="font-mono text-[10px] uppercase tracking-[0.3em] text-[#8E8E93]">
          EST. 2026 — JEREMIAH WOMACK
        </span>
        <span className="font-mono text-[10px] uppercase tracking-[0.3em] text-[#8E8E93]">
          SCROLL ↓
        </span>
      </motion.div>
    </section>
  );
};
